<template>
  <!-- banner topo-->
  <div v-if="bannerTopo != ''" class="slider-area">
    <div class="slider-height2 slider-bg2 d-flex align-items-center">
      <div class="container">
        <div class="row align-items-center">
          <div class="offset-xl-1 col-xl-5 col-lg-5 col-md-5">
            <div class="hero-caption hero-caption2">
              <h2>{{ bannerTopo[0].itiNome }}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END banner topo-->

  <!--?  Contact Area start  -->
  <section class="contact-section">
    <div v-if="contato != ''" class="container">

      <div class="row">
        <div class="col-12">
          <h2 class="contact-title">{{ contato[0].itiCampoExtra1 }}</h2>
        </div>
        <div class="col-lg-8 mb-80">
          <form class="form-contact contact_form">
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <textarea class="form-control w-100" v-model="formulario.mensagem" cols="30" rows="9"
                    placeholder="Mensagem"></textarea>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="form-group">
                  <input class="form-control valid" v-model="formulario.nome" type="text" placeholder="Nome" />
                </div>
              </div>

              <div class="col-sm-6">
                <div class="form-group">
                  <input v-mask="'(##) #####-####'" class="form-control" v-model="formulario.telefone" type="text"
                    placeholder="Telefone" />
                </div>
              </div>

              <div class="col-12">
                <div class="form-group">
                  <input class="form-control valid" v-model="formulario.email" type="email" placeholder="E-mail" />
                </div>
              </div>

            </div>

            <div class="form-group mt-3">
              <button class="button button-contactForm boxed-btn" @click.prevent="enviaremail()">Enviar
                Contato</button>
            </div>
          </form>
        </div>

        <div class="col-lg-3 offset-lg-1">
          <div class="media contact-info">
            <span class="contact-info__icon"><i class="ti-home"></i></span>
            <div class="media-body">
              <h3 v-html="contato[0].itiResumo1"></h3>
            </div>
          </div>
          <div class="media contact-info">
            <span class="contact-info__icon"><i class="ti-tablet"></i></span>
            <div class="media-body">
              <h3>{{ contato[0].itiCampoExtra3 }}</h3>
            </div>
          </div>
          <div class="media contact-info">
            <span class="contact-info__icon"><i class="ti-email"></i></span>
            <div class="media-body">
              <h3>{{ contato[0].itiCampoExtra5 }}</h3>
            </div>
          </div>
        </div>
      </div>

      <!-- mapa -->
      <section>
        <iframe v-if="contato != ''"
          :src="'https://www.google.com/maps/embed/v1/place?key=AIzaSyDmXp4J53f9Wt7iHX7dzIn7rHG7yL-EXXo&q=' + contato[0].itiCampoExtra6"
          width="100%" height="500px" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false"
          tabindex="0"></iframe>
      </section>
      <!-- END mapa -->

    </div>
  </section>
  <!-- Contact Area End -->

</template>

<script>
import { useHead } from '@vueuse/head'
import axios from 'axios';

export default {
  name: 'ContatoView',
  components: {
  },

  data: () => ({
    bannerTopo: [],
    contato: [],

    formulario: {
      nome: "",
      email: "",
      telefone: "",
      mensagem: "",
    }
  }),

  methods: {
    enviaremail() {
      if (this.formulario.nome == '' || this.formulario.nome == null) {
        this.$mensagemErro('Nome obrigatório!');
      }
      else if (this.formulario.email == '' || this.formulario.email == null) {
        this.$mensagemErro('E-mail obrigatório!');
      }
      else if (this.formulario.telefone == '' || this.formulario.telefone == null) {
        this.$mensagemErro('Telefone obrigatório!');
      }
      else {
        let _dadosEmail = {
          nomeDe: this.formulario.nome,
          nomePara: "FiançAqui Garantidora",
          assunto: 'Contato do Site - ' + this.formulario.nome,
          destinatario: this.contato[0].itiReferencia,
          emailResposta: this.formulario.email,
          textoEmail: 
          "Nome: " + this.formulario.nome + "<br>" + 
          "E-mail: " + this.formulario.email + "<br>" + 
          "Telefone: " + this.formulario.telefone + "<br>" + 
          "Mensagem: " + this.formulario.mensagem,
          nomeAnexo: '',
          anexo: '',
          tipoAnexo: '',
        }
        axios.post('/Process/AdmControleSmtp/Enviamail', _dadosEmail)
          .then(response => {
            this.$mensagemSucesso(response.data.message);
            this.limparFormulario();
          });
      }

    },

    limparFormulario() {
      this.formulario.nome = '';
      this.formulario.email = '';
      this.formulario.telefone = '';
      this.formulario.mensagem = '';
    },

    carregaMetas(texto, titulo) {
      useHead({
        title: 'FiançAqui Garantidora - ' + titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "FiançAqui Garantidora" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },
    removerTagsHTML(html) {
      const element = document.createElement('div');
      element.innerHTML = html;
      return element.textContent || element.innerText || '';
    },
  },

  created() {
    
    //aqui busca banner topo
    axios.get('/Process/InsInstitucional/institucional/51/topocontato/0/x')
      .then(response => {
        this.bannerTopo = response.data;
        this.carregaMetas(this.removerTagsHTML(this.bannerTopo[0].itiReferencia), this.bannerTopo[0].itiNome);
        //console.log('bannerTopo')
        //console.log(this.bannerTopo)
      })
      .catch(error => {
        console.error(error);
      });
    //aqui busca dados do contato
    axios.get('/Process/InsInstitucional/institucional/52/dadosdecontato/0/x')
      .then(response => {
        this.contato = response.data;
        console.log('contato')
        console.log(this.contato)
      })
      .catch(error => {
        console.error(error);
      });
  },
}
</script>

<style scoped></style>